import crypto from 'crypto';
import store from '@/store/index.js';

const checkModal = () => {
  window.bvModal.show('nice-id-check');
};

const getDiffTiem = () => {
  const vm = store.getters.vm;
  return new Promise((resolve) => {
    const d = Date.now();

    vm.$axios.get(`${process.env.VUE_APP_TEST_SERVER}/auth/diff_time`, { params: { time: d } }).then((response) => {
      const resData = response.data.data;
      resolve(resData);
    });
  });
};

const getSEncData = (diff_time) => {
  const vm = store.getters.vm;
  return new Promise((resolve, reject) => {
    const d = Date.now();
    const calc_time = d + diff_time;
    const usrCd = store.getters.userCode;
    const hash = crypto.createHash('sha256').update(`${usrCd}${calc_time}`).digest('hex');

    vm.$axios
      .get(`${process.env.VUE_APP_TEST_SERVER}/auth/nice/encrypt`, {
        params: { hash, time: calc_time },
      })
      .then((response) => {
        const resData = response.data.data;

        resolve(resData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const openNiceId = () => {
  let popup = window.open(
    '',
    'popupChk',
    'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no'
  );
  getDiffTiem().then((diff_time) => {
    getSEncData(diff_time)
      .then((sEncData) => {
        //* App.vue의 form_chk
        document.form_chk.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
        document.form_chk.EncodeData.value = sEncData;
        document.form_chk.target = 'popupChk';
        document.form_chk.submit();
      })
      .catch((err) => {
        popup.close();

        if (err.response.status === 401) {
          window.bvModal.show('login-required');
        } else {
          let errMsg = '';
          const errMessage = err.response.data.message;
          if (errMessage.split('|').length > 1) {
            errMsg = `
              ${errMessage.split('|')[0]}
              <br />
              ${errMessage.split('|')[1]}
              `;
          } else {
            errMsg = `${errMessage.split('|')[0]}`;
          }
          window.store.commit('setNiceIdDone', {
            success: false,
            content: errMsg,
            cancelBtn: false,
          });

          window.bvModal.show('nice-id-done');
        }
      });
  });
};

/*
  순서
  getDiffTime
  getSEncData
  openNiceId
*/

export default {
  install(Vue) {
    Vue.prototype.$nice_id = openNiceId;
    Vue.prototype.$nice_id_check = checkModal;
  },
};
